import { motion } from "framer-motion";
import { Building2, UserRound, FileSignature, Handshake } from "lucide-react";

const Node = ({ icon: Icon, title, sub, className }) => (
  <div className={`relative z-10 rounded-2xl border border-white/15 bg-white/[0.06] p-5 backdrop-blur ${className}`}>
    <Icon size={22} className="text-[#8FD3CE]" />
    <p className="mt-3 font-bold text-white">{title}</p>
    <p className="mt-1 text-sm text-slate-300">{sub}</p>
  </div>
);

export const DirectModel = () => (
  <div className="relative" data-testid="direct-model-diagram">
    <div className="grid gap-4 sm:grid-cols-2">
      <Node icon={UserRound} title="Arbeitskraft aus dem Ausland" sub="wird direkt bei Ihnen angestellt" />
      <Node icon={Building2} title="Ihr Unternehmen" sub="Arbeitgeber, zahlt das Gehalt" />
    </div>
    <motion.div
      initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
      className="my-4 flex origin-left items-center gap-3 rounded-2xl bg-[color:var(--teal)] px-5 py-4 text-white"
    >
      <FileSignature size={20} className="shrink-0" />
      <p className="text-sm font-semibold">Arbeitsvertrag direkt zwischen Arbeitskraft und Unternehmen</p>
    </motion.div>
    <div className="rounded-2xl border border-dashed border-white/25 p-5">
      <div className="flex items-start gap-3">
        <Handshake size={22} className="mt-0.5 shrink-0 text-[#8FD3CE]" />
        <div>
          <p className="font-bold text-white">PACTORA Personalpartner</p>
          <p className="mt-1 text-sm leading-relaxed text-slate-300">
            sucht, stellt vor und begleitet die Vermittlung bis zum vereinbarten Arbeitsbeginn. Vergütung über eine individuell vereinbarte Vermittlungsprovision des Unternehmens.
          </p>
        </div>
      </div>
    </div>
  </div>
);
